import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToRepairItemApiParams } from '#/api/aftersalesMgmt/repairItem/listQueryToApiParams';

/**
 * 維修品項列表。
 * GET `/aftersales/repair-item/search`
 * 供選取 repairItemId（報告建立／簽收）；非 SN／report selector。
 *
 * @param {object} listQuery
 */
export async function fetchRepairItemList(listQuery) {
  const { data: raw } = await request.get('/aftersales/repair-item/search', {
    params: listQueryToRepairItemApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
